import type { BulkJob } from "../../Types/accountQuery";

export const accountEditPending = (job: BulkJob) =>
  ["queued", "running", "submitted"].includes(job.status) ||
  !!job.counts.downstream_pending;

const labels: Record<string, string> = {
  tag: "Tag addition",
  remove_tags: "Tag removal",
  priority: "Priority update",
  assign: "Assignment update",
  leader: "Sales leader update",
  campaign: "Campaign change",
  archive: "Archive",
  unarchive: "Restore",
  delete: "Deletion",
  crm_link: "CRM sync",
  crm_refresh: "CRM refresh",
};
export const accountEditExceptions = (job: BulkJob) =>
  (job.counts.skipped ?? 0) + (job.counts.failed ?? 0) + (job.counts.review_required ?? 0);
export const accountEditLabel = (job: BulkJob) =>
  labels[job.kind] ?? "Account update";
export function accountEditSummary(job: BulkJob) {
  const label = accountEditLabel(job);
  const saved = job.counts.succeeded ?? 0;
  const skipped = job.counts.skipped ?? 0;
  const failed = (job.counts.failed ?? 0) + (job.counts.review_required ?? 0);
  if (accountEditPending(job))
    return `${label} in progress. You can keep working.`;
  return `${label} complete. ${saved.toLocaleString()} accounts updated${skipped ? `, ${skipped.toLocaleString()} skipped` : ""}${failed ? `, ${failed.toLocaleString()} need attention` : ""}.`;
}
